import simona from './avatars/simona.jpg';
import owocki from './avatars/owocki.jpg';
import marcusA from './avatars/marcusA.png';
import fabianV from './avatars/fabianV.jpg';
import marekO from './avatars/marekO.jpg';
import davidH from './avatars/davidH.png';
import agustinM from './avatars/agustinM.jpg';
import benD from './avatars/benD.jpeg';
import bethanyC from './avatars/bethanyC.jpg';
import billyL from './avatars/billyL.png';
import elliottB from './avatars/elliottB.jpg';
import gabrielT from './avatars/gabrielT.png';
import gregoryL from './avatars/gregoryL.jpg';
import joelT from './avatars/joelT.jpg';
import justineH from './avatars/justineH.jpg';
import kyleS from './avatars/kyleS.jpg';
import matthewM from './avatars/matthewM.jpg';
import niranB from './avatars/niranB.jpg';
import oshoJ from './avatars/oshoJ.jpg';
import rachelB from './avatars/rachelB.png';
import reka from './avatars/reka.jpg';
import trentV from './avatars/trentV.jpg';
import balajiS from './avatars/balajiS.jpg';
import allisonD from './avatars/allisonD.jpg';
import amyJ from './avatars/amyJ.jpg';
import azeemK from './avatars/azeemK.jpg';
import benF from './avatars/benF.jpg';
import benjiL from './avatars/benjiL.jpg';
import borisD from './avatars/borisD.jpg';
import connorS from './avatars/connorS.jpg';
import dimitriD from './avatars/dimitriD.jpg';
import donG from './avatars/donG.jpg';
import geordanS from './avatars/geordanS.jpg';
import helenaG from './avatars/helenaG.jpg';
import hudsonJ from './avatars/hudsonJ.jpg';
import jacobL from './avatars/jacobL.jpg';
import jonathanS from './avatars/jonathanS.png';
import joshuaB from './avatars/joshuaB.jpg';
import LaureH from './avatars/LaureH.jpg';
import manveerB from './avatars/manveerB.jpg';
import mariaM from './avatars/mariaM.jpg';
import martaB from './avatars/martaB.jpg';
import martinK from './avatars/martinK.jpg';
import michaelF from './avatars/michaelF.jpg';
import nathanS from './avatars/nathanS.jpg';
import omarE from './avatars/omarE.jpg';
import philH from './avatars/philH.jpg';
import richardB from './avatars/richardB.jpg';
import sageS from './avatars/sageS.jpg';
import sarahH from './avatars/sarahH.jpg';
import shadyE from './avatars/shadyE.png';
import staniK from './avatars/StaniK.jpg';
import tammyF from './avatars/tammyF.jpg';
import theresaK from './avatars/theresaK.jpg';
import tylerD from './avatars/tylerD.jpg';
import vivekS from './avatars/vivekS.jpg';
import yevM from './avatars/yevM.jpg';
import alexG from './avatars/alexG.jpg';
import timothyA from './avatars/timothyA.jpg';
import benjaminL from './avatars/benjaminL.jpg';
import abbeyT from './avatars/abbeyT.jpg';
import carlaO from './avatars/carlaO.jpg';
import davidA from './avatars/davidA.jpeg';
import derekA from './avatars/derekA.JPG';
import emilK from './avatars/emilK.jpeg';
import franciscoD from './avatars/franciscoD.jpg';
import erikA from './avatars/erikA.jpg';
import jeffreyJ from './avatars/jeffreyJ.jpg';
import jelaniC from './avatars/jelaniC.jpg';
import jesseH from './avatars/jesseH.jpg';
import jonathanK from './avatars/jonathanK.jpg';
import keithC from './avatars/keithC.jpg';
import matthewD from './avatars/Matthew_Duffy.png';
import michaelZ from './avatars/michaelZ.jpg';
import nanakN from './avatars/nanakN.jpg';
import reillyC from './avatars/Reilly_Capps.jpg';
import sovereignO from './avatars/Sovereign_Oshumare.jpeg';
import tomT from './avatars/tomT.jpg';
import travisF from './avatars/Travis_F.png';
import vjones from './avatars/Vjones.jpg';


export const speakersArray = [
  {
    name: `Simona\nPop`,
    company: 'Schelling Point Content Curator',
    twitter: 'https://twitter.com/Sim_Pop',
    avatar: simona
  },
  {
    name: 'Balaji\nSrinivasan',
    company: '',
    twitter: 'https://twitter.com/balajis',
    avatar: balajiS
  },
  {
    name: 'Kevin\nOwocki',
    company: 'supermodular.xyz',
    twitter: 'https://twitter.com/owocki',
    avatar: owocki
  },
  {
    name: 'Marcus\nAurelius',
    company: 'KlimaDAO',
    twitter: 'https://twitter.com/0xKlimaurelius',
    avatar: marcusA
  },
  {
    name: 'Rachel\nBrissenden',
    company: '',
    twitter: 'https://twitter.com/RachelRoseB',
    avatar: rachelB
  },
  {
    name: 'David\nHoffman',
    company: 'Bankless',
    twitter: 'https://twitter.com/TrustlessState',
    avatar: davidH
  },
  {
    name: 'Bethany\nCrystal',
    company: '',
    twitter: 'https://twitter.com/bethanymarz',
    avatar: bethanyC
  },
  {
    name: 'Niran\nBabalola',
    company: 'Panvala',
    twitter: 'https://twitter.com/niran',
    avatar: niranB
  },
  {
    name: 'Justine\nHumenansky',
    company: '',
    twitter: 'https://twitter.com/lalalavendr',
    avatar: justineH
  },
  {
    name: 'Trent\nVan Epps',
    company: 'Protocol Guild',
    twitter: 'https://twitter.com/trent_vanepps',
    avatar: trentV
  },
  {
    name: 'Joel\nThorstensson',
    company: 'Ceramic',
    twitter: 'https://twitter.com/joelthorst',
    avatar: joelT
  },
  {
    name: 'Billy\nLuedtke',
    company: '',
    twitter: 'https://twitter.com/0xbilly',
    avatar: billyL
  },
  {
    name: 'Gregory\nLandua',
    company: '',
    twitter: 'https://twitter.com/gregory_landua',
    avatar: gregoryL
  },
  {
    name: 'Manveer\nBasra',
    company: 'Scholar',
    twitter: 'https://twitter.com/manveerbasra_',
    avatar: manveerB
  },
  // {
  //   name: 'Osho\nJha',
  //   company: '',
  //   twitter: 'https://twitter.com/CryptoBroShoNYC',
  //   avatar: oshoJ
  // },
  {
    name: 'Reka.eth',
    company: '',
    twitter: 'https://twitter.com/reka_eth',
    avatar: reka
  },
  {
    name: 'Elliott\nBayev',
    company: '',
    twitter: 'https://twitter.com/elliottbayev',
    avatar: elliottB
  },
  {
    name: 'Agustin\nMatteri',
    company: '',
    twitter: 'https://twitter.com/agustin_matteri',
    avatar: agustinM
  },
  {
    name: 'Matthew\nMonahan',
    company: '',
    twitter: 'https://twitter.com/matthewmutual',
    avatar: matthewM
  },
  {
    name: 'Gabriel\nTumlos',
    company: '',
    twitter: 'https://twitter.com/bondwithmochi',
    avatar: gabrielT
  },
  {
    name: 'Ben\nDiFrancesco',
    company: '',
    twitter: 'https://twitter.com/bendifrancesco',
    avatar: benD
  },
  {
    name: 'Theresa\nKennedy',
    company: '',
    twitter: 'https://twitter.com/theresavkennedy',
    avatar: theresaK
  },
  {
    name: 'Kyle Smith\n| bestape',
    company: '',
    twitter: 'https://twitter.com/bestape',
    avatar: kyleS
  },
  {
    name: 'Marta\nBelcher',
    company: 'Filecoin Foundation',
    twitter: 'https://twitter.com/MartaBelcher',
    avatar: martaB
  },
  {
    name: 'Connor\nSpelliscy',
    company: '',
    twitter: 'https://twitter.com/c_spelliscy',
    avatar: connorS
  },
  {
    name: 'Nathan\nSchneider',
    company: '',
    twitter: 'https://twitter.com/ntnsndr',
    avatar: nathanS
  },
  {
    name: 'Yev\nMuchnik',
    company: '',
    twitter: 'https://twitter.com/MuchnikYev',
    avatar: yevM
  },
  // {
  //   name: 'Andrew Dickson',
  //   company: 'Drips',
  //   twitter: 'https://twitter.com/surfaquadreams',
  //   avatar: 
  // },
  {
    name: 'Amy\nJung',
    company: '',
    twitter: 'https://twitter.com/itsamyjung',
    avatar: amyJ
  },
  {
    name: 'Sarah\nHubbard',
    company: '',
    twitter: 'https://twitter.com/sarahhubba',
    avatar: sarahH
  },
  {
    name: 'Hudson\nJameson',
    company: '',
    twitter: 'https://twitter.com/hudsonjameson',
    avatar: hudsonJ
  },
  {
    name: 'Maria\nMagenes',
    company: '',
    twitter: 'https://twitter.com/mariamagenes1',
    avatar: mariaM
  },
  // {
  //   name: 'Geordan\nShannon',
  //   company: '',
  //   twitter: 'https://twitter.com/GeordanShannon',
  //   avatar: geordanS
  // },
  {
    name: 'Dimitri\nDe Jonghe',
    company: 'Nevermined',
    twitter: 'https://twitter.com/DimitriDeJonghe',
    avatar: dimitriD
  },
  {
    name: 'Fabian\nVogelsteller',
    company: 'Lukso',
    twitter: 'https://twitter.com/feindura',
    avatar: fabianV
  },
  {
    name: 'Stani\nKulechov',
    company: 'Aave',
    twitter: 'https://twitter.com/StaniKulechov',
    avatar: staniK
  },
  {
    name: 'Tyler\nDiorio',
    company: '',
    twitter: 'https://twitter.com/TylerDiorio',
    avatar: tylerD
  },
  {
    name: 'Vivek\nSingh',
    company: 'kernel',
    twitter: 'https://twitter.com/vsinghdothings',
    avatar: vivekS
  },
  {
    name: 'Helena\nGagern',
    company: '',
    twitter: 'https://twitter.com/HelenaGagern',
    avatar: helenaG
  },
  {
    name: 'Erik\nAllberg',
    company: 'dao.xyz',
    twitter: 'https://twitter.com/ErikAllberg',
    avatar: erikA
  },
  {
    name: 'Keith\nComito',
    company: 'Lifespan.io',
    twitter: 'https://twitter.com/keithcomito',
    avatar: keithC
  },
  {
    name: 'Jeffrey\nJoh',
    company: '',
    twitter: 'http://www.twitter.com/whatupjeff',
    avatar: jeffreyJ
  },
  {
    name: 'Michael\nZargham',
    company: 'BlockScience',
    twitter: 'https://twitter.com/mZargham',
    avatar: michaelZ
  },
  {
    name: 'Carla\nOstmann',
    company: 'DeSci Labs',
    twitter: 'https://twitter.com/carlaostmann',
    avatar: carlaO
  },
  {
    name: 'David\nAronchick',
    company: 'Protocol Labs',
    twitter: 'https://twitter.com/aronchick',
    avatar: davidA
  },
  {
    name: 'Emil\nKendziorra',
    company: 'CryoDAO',
    twitter: '',
    avatar: emilK
  },
  {
    name: 'Francisco\nDíaz',
    company: 'talentDAO',
    twitter: 'https://twitter.com/le_panch0',
    avatar: franciscoD
  },
  {
    name: 'Jelani\nClarke',
    company: 'DeSciWorld',
    twitter: 'https://twitter.com/JelaniC3?s=20',
    avatar: jelaniC
  },
  {
    name: 'Tom\nTrowbridge',
    company: 'Fluence Labs',
    twitter: 'https://twitter.com/TheTomTrow',
    avatar: tomT
  },
  
  {
    name: 'Derek\nAnderson',
    company: 'Blockless',
    twitter: 'https://twitter.com/dmikeyanderson',
    avatar: derekA
  },
  {
    name: 'Jesse\nHudson',
    company: 'Molecule',
    twitter: 'https://twitter.com/jsshdsn',
    avatar: jesseH
  },
  {
    name: 'Nanak\nNihal Khalsa',
    company: 'Holonym',
    twitter: 'https://twitter.com/nanaknihal',
    avatar: nanakN
  },

  // {
  //   name: '',
  //   company: '',
  //   twitter: '',
  //   avatar: 
  // },
  
  // DESCI
  {
    name: 'Benji\nLeibowitz',
    company: 'VitaDAO',
    twitter: 'https://twitter.com/benjileibo/',
    avatar: benjiL
  },
  {
    name: 'Jonathan Kung',
    company: 'Science Publishing DAO',
    twitter: '',
    avatar: jonathanK
  },
  {
    name: 'Boris\nDyakov',
    company: 'Gitcoin | LabDAO',
    twitter: 'https://twitter.com/BJ_Dyakov',
    avatar: borisD
  },
  {
    name: 'Jonathan\nStarr',
    company: 'Desci Labs',
    twitter: 'https://twitter.com/thejringo',
    avatar: jonathanS
  },
  {
    name: 'Shady\nEl Damaty',
    company: 'OpSci, Holonym',
    twitter: 'https://twitter.com/hebbianloop',
    avatar: shadyE
  },
  {
    name: 'Tammy\nFrancis',
    company: 'Catalyst 4 Change Global',
    twitter: 'http://www.twitter.com/drtammyfrancis',
    avatar: tammyF
  },
  {
    name: 'Azeem\nKhan',
    company: 'Gitcoin',
    twitter: 'https://twitter.com/azeemk_',
    avatar: azeemK
  },
  {
    name: 'Allison\nDuettmann',
    company: 'Foresight Institute',
    twitter: 'https://twitter.com/allisondman',
    avatar: allisonD
  },
  {
    name: 'Sage\nShelton',
    company: 'ReSci Network',
    twitter: 'https://twitter.com/renegaderegen',
    avatar: sageS
  },
  {
    name: 'Phil\nHedayatnia',
    company: 'Airfoil',
    twitter: 'https://twitter.com/philhedayatnia',
    avatar: philH
  },
  {
    name: 'Omar\nElNaggar',
    company: 'Weavechain',
    twitter: 'https://twitter.com/homercarpenter',
    avatar: omarE
  },
  {
    name: 'Don\nGossen',
    company: 'Nevermined AG',
    twitter: 'https://twitter.com/dongossen?t=-RVhlT8a_UMhUF5PlISp7g&s=09',
    avatar: donG
  },
  {
    name: 'Laure\nHaak',
    company: 'Mighty Red Barn',
    twitter: 'https://twitter.com/HaakYak',
    avatar: LaureH
  },
  {
    name: 'Martin\nKarlsson',
    company: 'Lateral.io/desci',
    twitter: 'https://twitter.com/jmartink',
    avatar: martinK
  },
  {
    name: 'Richard\nBlythman',
    company: 'Algovera',
    twitter: 'https://twitter.com/richardblythman?t=wXzlYmcWZdVzZRd24ZA6kw&s=09',
    avatar: richardB
  },
  {
    name: 'Michael\nFischer',
    company: 'DBDAO.xyz',
    twitter: 'https://twitter.com/0xMikeyF',
    avatar: michaelF
  },
  {
    name: 'Jacob\nLuo',
    company: 'Kdot',
    twitter: 'https://www.twitter.com/jacob_luo19',
    avatar: jacobL
  },
  {
    name: 'Joshua\nBate',
    company: 'DeSciWorld',
    twitter: 'https://twitter.com/jb87ua',
    avatar: joshuaB
  },
  {
     name: 'Marek\nOlszewski',
    company: 'Celo',
    twitter: 'https://twitter.com/marek_',
    avatar: marekO
  },
  {
    name: 'Abbey\nTitcomb',
   company: '',
   twitter: 'https://twitter.com/abbey_titcomb',
   avatar: abbeyT
 },
//   {
//     name: 'Alex\nGluchowski',
//    company: 'zkSync',
//    twitter: 'https://twitter.com/gluk64',
//    avatar: alexG
//  },
  {
    name: 'Timothy\nArcher',
    company: 'OpenCivics',
    twitter: 'https://twitter.com/thetimearcher',
    avatar: timothyA
  },
  {
    name: 'Benjamin\nLIfe',
    company: 'OpenCivics',
    twitter: 'https://twitter.com/omniharmonic',
    avatar: benjaminL
  },
  {
    name: 'Reilly\nCapps',
    company: '',
    twitter: 'https://twitter.com/ReillyCapps',
    avatar: reillyC
  },
  {
    name: 'Sovereign\nOshumare',
    company: '',
    twitter: 'https://twitter.com/s_oshumare',
    avatar: sovereignO
  },
  {
    name: 'Valinda\nJones',
    company: '',
    twitter: 'https://twitter.com/missmetadata/',
    avatar: vjones
  },
  {
    name: 'Matthew\nDuffy',
    company: '',
    twitter: 'https://twitter.com/duffmaestri',
    avatar: matthewD
  },
  {
    name: 'Travis\nFluck',
    company: '',
    twitter: 'https://www.instagram.com/view_askew',
    avatar: travisF
  },
];